import React, { Fragment, useEffect, useState, useRef } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { MaterialReactTable } from 'material-react-table'
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import { PAGES } from '../../Constants/CommonConstants';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import { getDate } from '../../utils/Helper';
import { ServiceGetAction, ServiceAddAction, ServiceCategoryAddAction, ServiceStatusAction } from "../../Redux/Action/ServiceAction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { getDateFormatData } from "../../utils/Helper";
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { DashboardRedirectionAction } from "../../Redux/Action/CommonAction";
import { useIntl, FormattedMessage } from "react-intl";

function Service() {
  const intl = useIntl();
  const [data, setData] = useState<any>([]);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(['DESC']);
  const servicelist = useSelector((state: any) => state.SeriveGetState);
  const caregoryList = useSelector((state: any) => state.ServiceCategoryState?.data?.data);
  const ServiceStatus = useSelector((state: any) => state.ServiceStatusState);
  const DashboardRedirectionStatedata = useSelector((state: any) => state.DashboardRedirectionState)

  const formRef = useRef<HTMLFormElement>(null);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [openSerach, setOpenSerach] = useState(false)
  const [serachstatus, setSerachstatus] = useState<any>('')

  const handleFilterValue = (e: any) => {
    const { name, value } = e.target;
    setSerachstatus((prevStatus: any) => ({ ...prevStatus, [name]: value, }));
  };

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState('');
  const [rowCount, setRowCount] = useState(0);
  const log_in = useSelector((state: any) => state.ServiceGetState)
  // Table Coulmns
  useEffect(() => {
    const data = {
      id: 1
    }
    dispatch(ServiceCategoryAddAction(data))
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data?.salon_id;

        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );

        query.columnFilters.push({ id: "salon_id", value: userStatus })
        dispatch(DashboardRedirectionAction('RESET'));
        await dispatch(ServiceGetAction(query));
        setLoading(false)

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    ServiceStatus.loading
  ]);
  useEffect(() => {
    setData(servicelist?.data?.data?.rows);
    setRowCount(servicelist?.data?.data?.count);
  }, [servicelist?.data]);

  const handleStatuschange = (row: any) => {
    // return  console.log(row)
    setLoading(true)
    const data = {
      status: row.status == 1 ? 0 : 1,
      status_id: row.id
    }
    dispatch(ServiceStatusAction(data))
  }
  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: intl.formatMessage({ id: 's_no' }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'name',
      header: intl.formatMessage({ id: 'name' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'duration',
      header: intl.formatMessage({ id: 'duration' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'price',
      header: intl.formatMessage({ id: 'price' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'salon_details.salon_name',
      header: intl.formatMessage({ id: 'salon_name' }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at',
      header: intl.formatMessage({ id: 'created_at' }),
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: 'updated_at',
      header: intl.formatMessage({ id: 'updated_at' }),
      accessorFn: (row: { updated_at: any; }) => getDate(row.updated_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: 'status' }),
      size: 50,
      accessorFn: (row: { id: any, status: number }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <label className="switch">
              <input type="checkbox" checked={row.status == 1} onChange={() => handleStatuschange(row)} />
              <span className="slider round"></span>
            </label>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      header: intl.formatMessage({ id: 'action' }),
      size: 30,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`service-details`}
                pageID={row?.id}
                showEdit={false}
                showView={true}
                showDelete={false}
              />

            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];


  const handeldate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setStartDate(formattedDate);
  }

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setEndDate(formattedDate)
  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      { id: "start_date", value: startDate.trim() },
      { id: "end_date", value: endDate.trim() },
      { id: "search", value: serachstatus?.namesearch?.trim() },
      { id: "category_id", value: serachstatus?.category },
      { id: "status", value: serachstatus?.services }

    ]
    setColumnFilters(columnFilters)
    setOpenSerach(true)
  }
  const resetSearchfilter = () => {
    setOpenSerach(false)
    setStartDate('')
    setEndDate('')
    setSerachstatus('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" },
      { id: "category_id", value: "" },
      { id: "status", value: "" }

    ]
    setColumnFilters(columnFilters)

  }

  return (
    <Fragment>
      {loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title={<FormattedMessage id="service_management" />}
        breadcrumbs={{
          secLast: { 'link': '/service', 'name': <FormattedMessage id="service_management" /> },
        }}
        buttons={[
          { url: '/service-add', className: 'btn btn-success', text: '+ Add Service', show: false }, // This button will be shown
        ]}
      >


        <form ref={formRef} onSubmit={handleserach}>

          <div className='row gy-3 mt-3 mb-4'>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="start_date" /></label>
              <DatePicker className="form-control" placeholderText={intl.formatMessage({ id: 'date_placeholder' })} value={startDate ? getDateFormatData(startDate) : ''} onChange={(e) => handeldate(e)} onKeyDown={(e) => e.preventDefault()} />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="end_date" /></label>
              <DatePicker className="form-control" placeholderText={intl.formatMessage({ id: 'date_placeholder' })} value={endDate ? getDateFormatData(endDate) : ''} onChange={(e) => handelEnddate(e)} minDate={new Date(startDate)} onKeyDown={(e) => e.preventDefault()} />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="all_category" /></label>
              <select className='form-select shadow-none' name="category" id="cars" onChange={handleFilterValue}>
                <option value="">{intl.formatMessage({ id: 'all_category' })}</option>
                {caregoryList && caregoryList.map((res: any, i: any) => (
                  <option value={res.id} key={i} >{res.name}</option>
                ))}
              </select>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="services_status" /></label>
              <select className='form-select shadow-none' name="services" id="cars" onChange={handleFilterValue}>
                <option value="">{intl.formatMessage({ id: 'all_services' })}</option>
                <option value="1">{intl.formatMessage({ id: 'active_services' })}</option>
                <option value="0">{intl.formatMessage({ id: 'deactive_services' })}</option>
              </select>
            </div>
            <div className="row gy-3">
              <div className='col-md-6 col-lg-4 col-xl-3'>
                <div className="input-group w-100">
                  <div className="input-group">
                    <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                    <input type='text' id="saerchId" name="namesearch" className="form-control m-0" placeholder={intl.formatMessage({ id: 'search_by_name' })} onChange={handleFilterValue} />
                  </div>
                </div>
              </div>

              <div className="col-6">
                <button className='btn theme-bg text-white me-2'><FormattedMessage id="filter" /></button>
                <button className='btn btn-success' onClick={() => resetSearchfilter()} ><FormattedMessage id="reset" /></button>
              </div>
            </div>
          </div>
        </form>
        {
          data &&
          <MaterialReactTable

            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: 'error_loading_data' }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: 'search_from_name' }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default Service;